import styled from '@emotion/styled'

export const DepartmentsUIWrapper = styled.div`
  display: flex;
  padding-top:100px;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  .logo{
    padding-bottom:56px;
    height: 157px;
  }
  .pageHeader{
    font-size:32px;
    color: #000000;
    margin-bottom:50px;
    margin-top:50px;
  }
  .deptListContainer{
    padding-bottom:60px;
  }
  .deptOption{
    background: #EDEDED;
    border-radius: 9px;
    min-width:300px;
    height: 64px;
    color: #000000;
    font-size:24px;
    margin-bottom:15px;
    margin-top:15px;
    text-transform:none !important;
    :hover{
        background: #21C769;
        font-size:20px;
    }
  }
  `;